import React from 'react';

import PaymentBody from '../../Components/PaymentBody';

import getPaymentBodyConfig from './PaymentBodyConfig';

import { Dimensions, Platform } from 'react-native'

const PaymentBodyContainer = ({ screen, customTickLottie, navigateToScreen, goBackView, isCenter, _toggleModal, ...props }) => {
  const width = Dimensions.get('window').width > 700
  const platform = Platform.OS === 'web'
  const isDesktopWeb = width && platform

  const options = getPaymentBodyConfig({ ...props, isDesktopWeb: isDesktopWeb })

  return <PaymentBody {...options[screen]} customTickLottie={customTickLottie} goBackView={goBackView} isCenter={isCenter} _toggleModal={_toggleModal} />
};

PaymentBodyContainer.defaultProps = {
  error: {},
};

PaymentBodyContainer.propTypes = {
  ...PaymentBody.propTypes,
};
export default PaymentBodyContainer;
